// extracted by mini-css-extract-plugin
export default {"container":"GroupLayerMaxItems_container__zOvlX","children":"GroupLayerMaxItems_children__SS0so","input":"GroupLayerMaxItems_input__sxL5L"};